module.exports = __webpack_public_path__ + "img/portal.4156e537.png";